// eslint-disable-next-line import/prefer-default-export
export const BookingStatus = Object.freeze({
  Success: 0,
  Error: 1,
  Loading: 2,
});
